/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { CellSelection, selectionCell } from "prosemirror-tables";

const selectColumn = () => {

    /** @type {import("@tiptap/core").Command} */
    return function ({ state, dispatch, tr }) {

        if (dispatch) {
            const cellPosition = selectionCell(state);
            const selection = CellSelection.colSelection(cellPosition);

            tr.setSelection(selection);
        }

        return true;
    };
};
export { selectColumn };
